// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__iqNKa","requiredAsterisk":"Info_requiredAsterisk__2FH9b"};